import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import ICustomer from "@/interfaces/customer.interfaces";
import customerService from "@/services/customer.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetCustomerByIdReturn = RequestsBaseReturn<ICustomer | null>;

export type UseGetCustomerByIdProps = ByIdRequestProps;

type UseSwrGetCustomerByIdParams = [string, number];
const useGetCustomerById = ({ _id }: UseGetCustomerByIdProps): UseGetCustomerByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<ICustomer, Error, UseSwrGetCustomerByIdParams | null>(
    _id ? [SWR_KEYS.getCustomerById, _id] : null,
    ([, customerId]) => customerService.getCustomerById(customerId),
    { 
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      refreshInterval: 0
    }
  );

  return { data, isLoading, error };
};

export default useGetCustomerById;
